// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadAboveObserver__container-b4c03d {
  position: relative;
  bottom: -5px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/LoadAboveObserver/LoadAboveObserver.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;AACF","sourcesContent":[".container {\n  position: relative;\n  bottom: -5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LoadAboveObserver__container-b4c03d`
};
module.exports = ___CSS_LOADER_EXPORT___;
